// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.camera-container {
  position: absolute;
  top: 50vh;
  top: 50svh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 640px;
  background-color: #838181;
  border-radius: 8px;
  overflow: hidden;
  aspect-ratio: 16/10;
  /* Default landscape aspect ratio */
  transition: aspect-ratio 0.4s ease;
  border: 4px dotted yellow;
  box-sizing: border-box;
}
.camera-container.selfie-mode {
  max-width: 400px;
  aspect-ratio: 1/1;
  margin-bottom: 200px;
}

.camera-view {
  flex: 2;
  min-width: 300px;
}

.main-content {
  background-color: black;
  display: flex;
  flex-wrap: wrap;
  padding: 1.5rem;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

.myVideo {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.expo {
  font-size: 90px;
  z-index: 20000;
}

.expo-container {
  position: fixed;
  left: 50%;
  bottom: -50px;
  transform: translate(-50%, -50%);
  margin: 0 auto;
}

.mat-icon {
  height: 90px;
  width: 90px;
  font-size: 90px;
  line-height: 90px;
}

.mat-icon-button {
  width: auto;
  height: auto;
}

.scanner-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}

.capture-button {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 5px 5px;
  font-size: 14px;
  z-index: 2;
  color: red;
}

.instruction-line-container {
  position: absolute;
  top: 120px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 12px;
  z-index: 2;
  background-color: #545454;
  border-radius: 15px;
  width: 90%;
}
.instruction-line-container.isDesktop {
  width: 50%;
}

.instruction-line {
  color: white;
  font-size: 18px;
}

.rotation-warning {
  border-radius: 8px;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 0 auto;
  background-color: whitesmoke;
}

.text-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
